import TeacherOffersForm from './TeacherOffersForm.component';

export default TeacherOffersForm;
